let brandId = ''

if (window.location.pathname.includes('/jobs/')) {
  brandId = window.location.pathname.split('/')[2]
} else {
  brandId = window.location.pathname.split('/')[1]
}

getEnvironment()

let styleHtml = '<link rel="stylesheet" type="text/css" href="https://cdn.staffmarkcms.com/css/template-style.css" />';
if (sessionStorage.getItem('brandId') !== 'internal' && sessionStorage.getItem('brandId') !== 'internal-confidential') {
  styleHtml += '<link rel="stylesheet" type="text/css" href="https://cdn.staffmarkcms.com/css/' + brandId + '-styles.css" />'
}
styleHtml += '<link rel="stylesheet" type="text/css" href="../assets/css/animate.css" />'
styleHtml += '<link rel="stylesheet" type="text/css" href="../assets/css/style.css" />'
document.head.innerHTML += styleHtml;

$.ajax({
  type: "POST",
  url: sessionStorage.getItem('apiHost') + 'Api/GetBrandDetails/' + brandId,
  success: function (data) {
    console.log(data)
    sessionStorage.setItem('brandName', data.brandName);
    sessionStorage.setItem('siteIconUrl', data.siteIconUrl);
    sessionStorage.setItem('headerHtml', data.headerHtml);
    sessionStorage.setItem('companyStatement', data.companyStatement);
    sessionStorage.setItem('homePageUrl', data.homePageUrl);
    sessionStorage.setItem('logoImageUrl', '../assets/img/' + data.logoImageUrl);
    $("#browserIcon").attr("href", sessionStorage.getItem('siteIconUrl'));
  },
  contentType: 'application/json',
  async: false,
  dataType: 'json'
});


const searchDiv = document.getElementById("errorPage");

searchDiv.innerHTML = brandId !== 'internal-confidential' ?
  `
  <div id="headerRow" class="d-flex flex-column align-self-center">
      <a id="homePage" class="mx-auto" href="${sessionStorage.getItem('homePageUrl')}">
        <img id="applicationLogoHeader" alt="${sessionStorage.getItem('brandName')} Logo" src="${sessionStorage.getItem('logoImageUrl')}" >
      </a>
    <p class="col-10 h4 text-center" style="margin-top: 10%">We're sorry, the Position you have requested is no longer available.</p>
    <button type="button" id="returnToSearch" class="btn btn-application">Search Active Job Postings</button>
  </div>
` :
  `<p class="col-10 h4 text-center" style="padding-top: 20%">We're sorry, the Position you have requested is no longer available.</p>
    <button type="button" id="returnToSearch" class="btn btn-application">Search Active Job Postings</button>`

const returnToSearch = document.querySelector('#returnToSearch')
returnToSearch.addEventListener('click', () => {
  window.open('../' + brandId, '_self')
})

let footerHtml =
  `
        <footer>
        <div id="global-footer-bottom" class="d-flex flex-row justify-content-between align-items-center mx-3">
          <div class="pl-2">Copyright &copy; ${new Date().getFullYear()} Staffmark Group - All Rights Reserved</div>
          <div class="text-right">
              <a href="https://www.staffmarkgroup.com/terms" target="_blank">Terms and Conditions</a> / <a
                  href="https://www.staffmarkgroup.com/privacy" target="_blank">Privacy Policy</a> / <a
                  href="https://www.staffmarkgroup.com/accessibility" target="_blank">Accessibility Statement</a> / <a
                  href="https://www.employeeworkplace.com/web-forms/communication-preferences" target="_blank">Communication
              Preferences</a>
          </div>
          </div>
        </footer>
    `
$('body').append(footerHtml)

function getEnvironment(){
  let hostName = window.location.hostname;
  let envName = '';
  let apiHost = '';
  let pageHost = '';
  if(hostName === 'localhost' || hostName.includes('dev2')){
    envName = 'dev2';
    apiHost = 'https://dev2.api.employeeworkplace.com/'
    pageHost = 'https://dev2.employeeworkplace.com/'
  }
  else if(hostName.includes('uat2')){
    envName = 'uat2';
    apiHost = 'https://uat2.api.employeeworkplace.com/'
    pageHost = 'https://uat2.employeeworkplace.com/'
  }else{
    envName = 'prod';
    apiHost = 'https://api.employeeworkplace.com/'
    pageHost = 'https://employeeworkplace.com/'
  }
  sessionStorage.setItem('envName', envName);
  sessionStorage.setItem('apiHost', apiHost);
  sessionStorage.setItem('pageHost', pageHost);
};
